import React from 'react';
import { CloudOff, Crown } from 'lucide-react';
import { useReadyTranslation } from '../hooks/useReadyTranslation';
import { GATE_VARIANT } from '../lib/offline/proGate';
import { Ventana, BOTON_VENTANA_PRINCIPAL, BOTON_VENTANA_SECUNDARIO, TONOS_DEL_ICONO_DE_VENTANA } from './alumno';

/**
 * OfflineProModal: la cara del candado D-G (F6.7b, fase 3).
 *
 * Se pinta SOLO cuando alguien sin Pro intenta iniciar una sesion de estudio con el vigia
 * dictaminando que no hay senal. Con senal nadie la ve jamas.
 *
 * pantallas-alumno (C, CE9-a y CE9-b): la ventana del Panel (`components/alumno/Ventana`: 440 en
 * computadora, hoja desde abajo en el celular, velo sobre toda la pantalla), SIN X (como hoy): la
 * nube tachada en su cuadro de 56, el texto de hoy, "Back" y "Upgrade to Pro" (el invitado: la
 * frase de mas y "Create account"). El velo y Esc cierran, como el velo de antes.
 * Cotejo con el PDF (CE9-a, p29): "Upgrade to Pro" lleva la corona de Pro de la casa; "Create account" (CE9-b), no.
 * Remate (R5, CE9-a como el PDF): la nube va en el cuadro naranja suave de los iconos de ventana, no en gris.
 */
export default function OfflineProModal({ variant, onUpgrade, onClose }) {
  const { t, ready } = useReadyTranslation(['modals', 'common']);
  if (!ready) return null;

  const isGuest = variant === GATE_VARIANT.GUEST;

  return (
    <Ventana
      alCerrar={onClose}
      testid="offline-pro-modal"
      botones={(
        <>
          <button type="button" onClick={onClose} className={BOTON_VENTANA_SECUNDARIO} data-testid="offline-pro-back-btn">
            {t('modals:offline_pro.back_btn')}
          </button>
          <button type="button" onClick={onUpgrade} className={BOTON_VENTANA_PRINCIPAL} data-testid="offline-pro-cta-btn">
            {isGuest ? null : <Crown className="w-4 h-4 shrink-0" aria-hidden="true" />}
            {t(isGuest ? 'modals:offline_pro.guest_cta' : 'modals:offline_pro.cta')}
          </button>
        </>
      )}
    >
      <div aria-hidden="true" data-testid="offline-pro-icono" className="-mt-3 w-14 h-14 rounded-2xl flex items-center justify-center mb-4"
        style={{ backgroundColor: TONOS_DEL_ICONO_DE_VENTANA.naranja.fondo, color: TONOS_DEL_ICONO_DE_VENTANA.naranja.icono }}>
        <CloudOff className="w-[26px] h-[26px]" />
      </div>
      <p className="text-[14px] leading-[21px] text-[#C8C8C8]" data-testid="offline-pro-body">
        {t('modals:offline_pro.body')}
      </p>
      {isGuest && (
        <p className="text-[14px] leading-[21px] text-[#C8C8C8] mt-3" data-testid="offline-pro-guest-tail">
          {t('modals:offline_pro.guest_tail')}
        </p>
      )}
    </Ventana>
  );
}
